import styled from 'styled-components'
import { colors } from '../shared/config'

const DBHeader = styled.div`
  z-index: 2001;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: #FFFCB5;
  width: 100%;
  padding: 0.2em 0;
  color: white;
  font-family: 'ITC Century';
  font-style: normal;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;
  line-height: 21.6px;
  z-index: 10;

  a {
    color:#9E7EC7;  
    text-decoration: none; /* Remove underline */
  }
`;

const Header = () => {
  return (
    <DBHeader>
      <a href="https://dailybruin.com">
        Daily Bruin
      </a>
    </DBHeader>
  )
}

export default Header;
